<template>
  <b-container style="max-width:480px;">
    <h1>{{ $t('setup.start.title') }}</h1>
    <b-container class="text-left">
      <p><b>{{ $t('setup.start.message') }}</b></p>
      <ol>
        <li><p>{{ $t('setup.start.step1') }}</p></li>
        <li>
          <p v-html="$t('setup.start.step2')"></p>
          <p>{{ $t('setup.start.step2advice') }}</p>
        </li>
      </ol>
    </b-container>
  </b-container>
</template>

<script>
import axios from 'axios';

// set global timeout for http requests
axios.defaults.timeout = 20000;

export default {
  name: 'HomePage',
  data: function () {
    return {
      interval: ''
    }
  },
  created () {
    if (!this.interval) {
      this.interval = setInterval(this.sensorIsReachable, 2000);
    }
  },
  beforeDestroyed () {
    if (!this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    getMac() {
      axios
        .get('http://10.3.141.1:6762/api/v1/mac')
        .then(response => {
          if (response.status == 200) {
            clearInterval(this.interval);
            this.$router.replace({ name: 'Setup' });
          }
        });
    },
    sensorIsReachable() {
      axios
        .get('http://10.3.141.1:6762', { timeout: 2000 })
        .catch(error => {
          if(error.response) {
            // user is in the same network as the sensor
            this.getMac();
          }
        });
    }
  }
}
</script>
